import { createReducer } from 'redux-act';
import { closeAlreadyLoggedInNotice, showAlreadyLoggedInNotice } from './accountLink.actions';

export interface IAccountLinkState {
  alreadyLoggedInNoticeOpen: boolean;
}

const defaultState: IAccountLinkState = {
  alreadyLoggedInNoticeOpen: false,
};

// Deliberately excluded from redux-persist: the notice answers a link the user just opened.
const reducer = createReducer<IAccountLinkState>({}, defaultState);

reducer
  .on(showAlreadyLoggedInNotice, (state) => ({ ...state, alreadyLoggedInNoticeOpen: true }))
  .on(closeAlreadyLoggedInNotice, (state) => ({ ...state, alreadyLoggedInNoticeOpen: false }));

export default reducer;



// WEBPACK FOOTER //
// ./src/services/accountLink/accountLink.reducer.ts